import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

export default function Loader({text , height}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={height? height :"60vh"} 
    >
      {/* Animated dots */}
      <Box display="flex" gap={1} mb={2}>
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            animate={{ y: [0, -10, 0] }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              delay: i * 0.2,
              ease: "easeInOut",
            }}
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: "#A40583",
            }}
          />
        ))}
      </Box>

      {/* Animated text */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <Typography
          fontFamily="Inter"
          fontWeight="500"
          fontSize="20px"
          color="#572575"
        >
         {text?text : "Loading Courses..."} 
        </Typography>
      </motion.div>
    </Box>
  );
}
